export class InventoryComponent extends HTMLElement {
    private inventory: string[] = [];

    public set data(inventory: string[]) {
        this.inventory = inventory;
        this.render();
    }

    /**
     * The render method of the Web Component
     * @memberof InventoryComponent
     * @returns {void}
     * @remarks This method will render the inventory of the player.
     * It will render the images of the items the player has in their inventory.
     * It will also filter out the PlasticBagItem from the inventory.
    */
    private render(): void {
        if (this.inventory.includes("PlasticBagItem")) {
            const filterOutPlasticBag: string[] = this.inventory.filter((item: string) => item !== "PlasticBagItem");
            this.innerHTML = `
                <div class="inventory-container">
                    ${filterOutPlasticBag.map((item: string) => this.renderInventoryItem(item)).join("")}
                </div>
            `;
        }
    }

    private renderInventoryItem(item: string): string {
        // render the newes 5 items
        // render the image of the item
        return `
            <div class="inventory-boxes">
                <img class='img-inventory' src="/assets/img/items/${item}.png" />
            </div>
        `;
    }
}
